"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionGridDisplay = exports.analyseCollectionDisplayColumns = void 0;
const lodash_1 = __importDefault(require("lodash"));
const GridDisplay_1 = require("./GridDisplay");
const dbgate_tools_1 = require("dbgate-tools");
function getObjectKeys(obj) {
    if (lodash_1.default.isArray(obj)) {
        return Object.keys(obj)
            .slice(0, 10)
            .map(x => parseInt(x));
    }
    if (lodash_1.default.isPlainObject(obj)) {
        return Object.keys(obj);
    }
    return [];
}
function createHeaderText(path) {
    let res = `${path[0]}`;
    for (let i = 1; i < path.length; i++) {
        const name = path[i];
        if (lodash_1.default.isNumber(name))
            res += `[${name}]`;
        else
            res += `.${name}`;
    }
    return res;
}
function getColumnsForObject(basePath, obj, res, display) {
    for (const name of getObjectKeys(obj)) {
        const uniqueName = [...basePath, name].join('.');
        let column = res.find(x => x.uniqueName == uniqueName);
        if (!column) {
            column = getDisplayColumn(basePath, name, display);
            if (basePath.length > 0) {
                const lastIndex1 = lodash_1.default.findLastIndex(res, x => x.parentHeaderText.startsWith(column.parentHeaderText));
                const lastIndex2 = lodash_1.default.findLastIndex(res, x => x.headerText == column.parentHeaderText);
                // console.log(uniqueName, lastIndex1, lastIndex2);
                if (lastIndex1 >= 0)
                    res.splice(lastIndex1 + 1, 0, column);
                else if (lastIndex2 >= 0)
                    res.splice(lastIndex2 + 1, 0, column);
                else
                    res.push(column);
            }
            else {
                res.push(column);
            }
        }
        if (lodash_1.default.isPlainObject(obj[name]) || lodash_1.default.isArray(obj[name])) {
            column.isExpandable = true;
        }
        if (display.isExpandedColumn(column.uniqueName)) {
            getColumnsForObject([...basePath, name], obj[name], res, display);
        }
    }
}
function getDisplayColumn(basePath, columnName, display) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const uniquePath = [...basePath, columnName];
    const uniqueName = uniquePath.join('.');
    return {
        columnName,
        headerText: createHeaderText(uniquePath),
        uniqueName,
        uniquePath,
        isStructured: true,
        parentHeaderText: createHeaderText(basePath),
        filterBehaviour: (_b = (_a = display === null || display === void 0 ? void 0 : display.driver) === null || _a === void 0 ? void 0 : _a.getFilterBehaviour(null, dbgate_tools_1.standardFilterBehaviours)) !== null && _b !== void 0 ? _b : dbgate_tools_1.mongoFilterBehaviour,
        pureName: (_c = display.collection) === null || _c === void 0 ? void 0 : _c.pureName,
        schemaName: (_d = display.collection) === null || _d === void 0 ? void 0 : _d.schemaName,
        isPartitionKey: !!((_f = (_e = display === null || display === void 0 ? void 0 : display.collection) === null || _e === void 0 ? void 0 : _e.partitionKey) === null || _f === void 0 ? void 0 : _f.find(x => x.columnName == uniqueName)),
        isClusterKey: !!((_h = (_g = display === null || display === void 0 ? void 0 : display.collection) === null || _g === void 0 ? void 0 : _g.clusterKey) === null || _h === void 0 ? void 0 : _h.find(x => x.columnName == uniqueName)),
        isUniqueKey: !!((_k = (_j = display === null || display === void 0 ? void 0 : display.collection) === null || _j === void 0 ? void 0 : _j.uniqueKey) === null || _k === void 0 ? void 0 : _k.find(x => x.columnName == uniqueName)),
    };
}
function analyseCollectionDisplayColumns(rows, display) {
    var _a;
    const res = [];
    const addedColumns = (_a = display === null || display === void 0 ? void 0 : display.config) === null || _a === void 0 ? void 0 : _a.addedColumns;
    for (const row of rows || []) {
        getColumnsForObject([], row, res, display);
    }
    for (const added of addedColumns || []) {
        if (res.find(x => x.uniqueName == added))
            continue;
        res.push(getDisplayColumn([], added, display));
    }
    return (res.map(col => (Object.assign(Object.assign({}, col), { isChecked: display.isColumnChecked(col) }))) || []);
}
exports.analyseCollectionDisplayColumns = analyseCollectionDisplayColumns;
class CollectionGridDisplay extends GridDisplay_1.GridDisplay {
    constructor(collection, driver, config, setConfig, cache, setCache, loadedRows, changeSet, readOnly = false, currentSettings = null) {
        var _a, _b;
        super(config, setConfig, cache, setCache, driver, undefined, undefined, currentSettings);
        this.collection = collection;
        const changedDocs = lodash_1.default.compact(changeSet.updates.map(chs => chs.document));
        const insertedDocs = lodash_1.default.compact(changeSet.inserts.map(chs => chs.fields));
        this.columns = analyseCollectionDisplayColumns([...(loadedRows || []), ...changedDocs, ...insertedDocs], this);
        this.filterable = true;
        this.sortable = true;
        this.editable = !readOnly && ((_a = collection === null || collection === void 0 ? void 0 : collection.uniqueKey) === null || _a === void 0 ? void 0 : _a.length) > 0;
        this.supportsReload = true;
        this.isDynamicStructure = true;
        this.changeSetKeyFields = (_b = collection === null || collection === void 0 ? void 0 : collection.uniqueKey) === null || _b === void 0 ? void 0 : _b.map(x => x.columnName);
        this.baseCollection = collection;
    }
}
exports.CollectionGridDisplay = CollectionGridDisplay;
